import { render, staticRenderFns } from "./MenuItemContent.vue?vue&type=template&id=52f23e28"
import script from "./MenuItemContent.vue?vue&type=script&lang=js"
export * from "./MenuItemContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports